<template>
  <div class="list-filter" :class="{ active: transShow }" @click="hideFilter">
    <div
      class="panel"
      :class="{ active: filterOpen }"
      :style="{
        paddingTop: `${barTop}px`
      }"
      @click.stop
    >
      <div v-if="transShow" class="filter-wrap">
        <filter-item
          v-if="filterList && filterList.length > 0"
          :list-data="filterList"
          :tmp-data="tmpBiNames"
          :call-key="'tmpBiNames'"
          :show-title="'名称'"
          @set-data="setTmpData"
        ></filter-item>
        <filter-item
          v-if="brandList && brandList.length > 0"
          :list-data="brandList"
          :tmp-data="tmpBrand"
          :call-key="'tmpBrand'"
          :show-title="'品牌'"
          @set-data="setTmpData"
        ></filter-item>
        <div class="price-filter-item" :class="!hasItem ? 'no-item' : ''">
          <div class="header">价格区间</div>
          <div class="price-range">
            <form-input
              v-model="minPrice"
              class="price-range-input"
              placeholder="最低价"
              @input="getMinPrice"
            ></form-input>
            <div class="line"></div>
            <form-input
              v-model="maxPrice"
              placeholder="最高价"
              class="price-range-input"
              @input="getMaxPrice"
            ></form-input>
          </div>
        </div>
      </div>
      <div
        v-if="transShow"
        class="btn-bar cf"
        :style="{ bottom: `${barBottom}px` }"
      >
        <div class="btn" @click="handleReset(0)">重置</div>
        <div
          class="btn active"
          :class="{ ...themeAppColorClass }"
          @click="handleConfirm()"
        >
          确定
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FormInput from '@/common/widgets/form_input'
import FilterItem from './FilterItem.vue'
export default {
  components: {
    FilterItem,
    FormInput
  },
  data() {
    return {
      transShow: false,
      tmpBrand: '',
      tmpBiNames: [],
      confirmLoading: false
    }
  },
  computed: {
    ...mapState('pop', {
      filterOpen: state => state.filterOpen,
      filterList: state => state.filterList,
      brandList: state => state.brandList,
      filterKey: state => state.filterKey,
      selectedBrand: state => state.selectedBrand,
      queryData: state => state.queryData,
      minPrice: state => state.minPrice,
      maxPrice: state => state.maxPrice
    }),
    hasItem() {
      return this.filterList && this.filterList.length
    },
    barTop() {
      return this.statusBarHeight
    },
    barBottom() {
      return this.safeBottomMargin
    }
  },
  watch: {
    filterOpen: function (newVal) {
      if (newVal) {
        this.transShow = newVal
        this.initData()
      } else {
        setTimeout(
          function () {
            this.transShow = newVal
          }.bind(this),
          300
        )
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    ...mapActions('pop', [
      'openFilter',
      'selectFilter',
      'setActQueryData',
      'getActivitySkuList',
      'setFilterSort',
      'setPrice'
    ]),
    // 初始化数据
    initData() {
      this.tmpBrand = this.selectedBrand
      this.tmpBiNames = [...this.filterKey]
    },
    getMinPrice(val) {
      this.validateValue(val)
      this.setPrice({ type: 'minPrice', value: val })
    },
    getMaxPrice(val) {
      this.validateValue(val)
      this.setPrice({ type: 'maxPrice', value: val })
    },
    validateValue(value) {
      const numberValue = Number(value)
      if (!numberValue && numberValue !== 0) {
        this.$toast({
          message: '请输入0到9999的数字',
          position: 'bottom'
        })
        return false
      } else {
        if (value && value.toString().indexOf('.') > -1) {
          if (value.split('.')[1].length > 2) {
            this.$toast({
              message: '最多输入两位小数',
              position: 'bottom'
            })
            return false
          } else if (numberValue < 0 || numberValue > 9999.99) {
            this.$toast({
              message: '请输入0到9999的数字',
              position: 'bottom'
            })
            return false
          }
        } else if (value && value.toString().indexOf('.') === -1) {
          if (!/^\d+$/.test(value) || numberValue < 0 || numberValue > 9999) {
            this.$toast({
              message: '请输入0到9999的数字',
              position: 'bottom'
            })
            return false
          }
        }
      }
      return true
    },
    // 子组件的回调
    setTmpData(key, value) {
      if (key === 'tmpBrand') {
        if (value === this[key]) {
          this[key] = ''
        } else {
          this[key] = value
        }
      } else {
        if (this[key].indexOf(value) > -1) {
          this[key].splice(this[key].indexOf(value), 1)
        } else {
          this[key].push(value)
        }
      }
    },
    // 重置数据
    resetTmpData() {
      this.tmpBrand = ''
      this.tmpBiNames = []
      this.setPrice({ type: 'minPrice', value: '' })
      this.setPrice({ type: 'maxPrice', value: '' })
    },
    // 点击隐藏
    hideFilter() {
      this.resetTmpData()
      this.openFilter()
    },
    // 点击重置
    handleReset(id) {
      this.resetTmpData()
    },
    setQueryData(name, data) {
      const queryObj = {}
      queryObj[name] = data
      this.setActQueryData(queryObj)
    },
    // 点击确认
    handleConfirm() {
      if (this.minPrice) {
        const isMinValidate = this.validateValue(this.minPrice)
        if (!isMinValidate) {
          return
        }
      }
      if (this.maxPrice) {
        const isMaxValidate = this.validateValue(this.maxPrice)
        if (!isMaxValidate) {
          return
        }
      }

      if (this.confirmLoading === true) return
      this.confirmLoading = true
      const brands = []
      if (this.tmpBrand) {
        brands.push(this.tmpBrand)
      }
      this.setQueryData('page', 1)
      this.setQueryData('brands', brands)
      this.setQueryData('biNames', this.tmpBiNames)
      this.setQueryData('bottomPrice', this.minPrice)
      this.setQueryData('topPrice', this.maxPrice)
      this.getActivitySkuList(this.queryData)
      if (
        brands.length ||
        this.tmpBiNames.length ||
        this.minPrice.trim().length ||
        this.maxPrice.trim().length
      ) {
        this.setFilterSort(true)
      } else {
        this.setFilterSort(false)
      }
      this.selectFilter({
        ids: this.tmpBiNames,
        brand: this.tmpBrand
      })
      setTimeout(() => {
        this.confirmLoading = false
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
.list-filter {
  display: block;

  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;

  width: 0;
  height: 0;

  background: rgba(0, 0, 0, 0.1);

  font-size: 0.32rem;

  transition: background 0.3s ease-in-out;
  &.active {
    z-index: 14;

    width: 100%;

    height: 100%;

    background: rgba(0, 0, 0, 0.6);
  }
  .panel {
    position: absolute;
    top: 0;
    right: -85%;

    width: 85%;
    height: 100%;

    background: #fff;

    transition: right 0.3s ease-in-out;

    box-sizing: border-box;
    &.active {
      right: 0;
    }
    .filter-wrap {
      height: 100%;
      padding: 0 0.3rem 1.3rem 0.3rem;
      overflow-y: auto;
    }
    .btn-bar {
      position: absolute;
      bottom: 0;
      left: 0;

      width: 100%;
      .btn {
        // display: inline-block;
        float: left;

        width: 50%;
        height: 44px;

        background: #fff;
        border-top: 1px solid #ebebeb;

        line-height: 45px;
        text-align: center;
        color: #666666;
        &.active {
          background: #0daf52;
          border-top: #0daf52;

          color: #fff;
          &.small {
            background: $theme-main_small;
            border-top: $theme-main_small;
          }
        }
      }
    }
  }
  .price-filter-item {
    padding-top: 0.4rem;
    &.no-item {
      margin-top: 0.48rem;
    }
    .header {
      font-size: 0.28rem;
      color: #4f5259;
    }
    .price-range {
      display: flex;

      margin-top: 16px;

      align-items: center;
      .price-range-input {
        display: flex;

        width: 2.4rem;
        height: 0.64rem;

        border-radius: 16px;
        border: 0.5px solid #cccccc;

        flex: none;
        align-items: center;

        font-size: 0.26rem;
        text-align: center;
        box-sizing: border-box;
      }
      .line {
        width: 0.24rem;
        height: 0.02rem;

        margin: 0 0.38rem;

        background: #cccccc;
      }
    }
  }
}
</style>
